import defaultCrownPng from '/img/icons/vipCrown.png';
import defaultCrownWebp from '/img/icons/vipCrown.webp';

export const crownImages = {
  default: {
    png: defaultCrownPng,
    webp: defaultCrownWebp,
  },
};
